interface NetscapeBookmark {
  url: string
  title: string
  description?: string
  addDate?: Date
  tags?: string[]
}

export function parseNetscapeBookmarks(html: string): NetscapeBookmark[] {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, "text/html")
  const bookmarks: NetscapeBookmark[] = []

  const links = doc.querySelectorAll("dt a[href]")

  for (const link of links) {
    const url = link.getAttribute("href")
    if (!url) continue

    const title = link.textContent?.trim() || url

    const addDateAttr = link.getAttribute("add_date")
    const addDate = addDateAttr
      ? new Date(Number.parseInt(addDateAttr) * 1000)
      : undefined

    const tagsAttr = link.getAttribute("tags")
    const tags = tagsAttr
      ? tagsAttr
          .split(",")
          .map(tag => tag.trim())
          .filter(Boolean)
      : undefined

    let description: string | undefined
    const nextElement = link.parentElement?.nextElementSibling
    if (nextElement?.tagName.toLowerCase() === "dd") {
      description = nextElement.textContent?.trim() || undefined
    }

    bookmarks.push({
      url,
      title,
      description,
      addDate,
      tags,
    })
  }

  return bookmarks
}

export function generateNetscapeBookmarks(
  bookmarks: NetscapeBookmark[],
): string {
  const lines = [
    "<!DOCTYPE NETSCAPE-Bookmark-file-1>",
    "<!-- This is an automatically generated file.",
    "     It will be read and overwritten.",
    "     DO NOT EDIT! -->",
    '<META HTTP-EQUIV="Content-Type" CONTENT="text/html; charset=UTF-8">',
    "<TITLE>Bookmarks</TITLE>",
    "<H1>Bookmarks</H1>",
    "<DL><p>",
  ]

  for (const bookmark of bookmarks) {
    let linkAttributes = `HREF="${escapeHtml(bookmark.url)}"`

    if (bookmark.addDate) {
      const timestamp = Math.floor(bookmark.addDate.getTime() / 1000)
      linkAttributes += ` ADD_DATE="${timestamp}"`
    }

    if (bookmark.tags && bookmark.tags.length > 0) {
      linkAttributes += ` TAGS="${escapeHtml(bookmark.tags.join(","))}"`
    }

    lines.push(`<DT><A ${linkAttributes}>${escapeHtml(bookmark.title)}</A>`)

    if (bookmark.description) {
      lines.push(`<DD>${escapeHtml(bookmark.description)}`)
    }
  }

  lines.push("</DL><p>")

  return lines.join("\n")
}

function escapeHtml(text: string): string {
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}
